import HttpClient from "utils/HttpClient/HttpClient"
import { SUCCESSFUL_GET_PAYMENTMETHOD } from "./actionConst";
import { SHOW_ERROR_MESSAGE } from 'reducers/application/actionConst';

export const fetchPaymentMethods = () => dispatch => {    
    new HttpClient(true).get("b2c/paymentmethod")
        .then((response) => {
            console.log("Successful Fetch PaymentMethod");
            dispatch({
                type: SUCCESSFUL_GET_PAYMENTMETHOD,
                payload: response.data
            });
        })
        .catch((error) => {
            console.log("Failed Fetch PaymentMethod");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        })
}


// WEBPACK FOOTER //
// ./src/reducers/paymentmethod/paymentmethodActions.js